<template>
  <div class="recommend-login">
    推荐好友
  </div>
</template>
<script>
export default {
  data () {
    return {
      referralCode:''
    }
  },
  mounted() {

  }
}
</script>
<style scoped lang="less">

</style>